import { createContext, useState } from "react";
import { InvoiceReasonModify } from "./InvoiceReasonModal";

export const InvoiceManagementContext = createContext({
    showDetail: false,
    setShowDetail: () => {},
    showConfirmRelease: false,
    setShowConfirmRelease: () => {},
    showEditInvoice: false,
    setShowEditInvoice: () => {},
    showReasonModal: false,
    setShowReasonModal: () => {},
    showUploadInvoice: false,
    setShowUploadInvoice: () => {},
    originalInvoiceId: null,
    setOriginalInvoiceId: () => {},
    reasonId: InvoiceReasonModify.Undefined,
    setReasonId: () => {},
});

const InvoiceManagementProvider = (props) => {
    const [showDetail, setShowDetail] = useState(false);
    const [showConfirmRelease, setShowConfirmRelease] = useState(false);
    const [showEditInvoice, setShowEditInvoice] = useState(false);
    const [showReasonModal, setShowReasonModal] = useState(false);
    const [showUploadInvoice, setShowUploadInvoice] = useState(false);
    const [originalInvoiceId, setOriginalInvoiceId] = useState(null);
    const [reasonId, setReasonId] = useState(InvoiceReasonModify.Undefined);

    const value = {
        showDetail,
        setShowDetail,
        showConfirmRelease,
        setShowConfirmRelease,
        showEditInvoice,
        setShowEditInvoice,
        showReasonModal,
        setShowReasonModal,
        showUploadInvoice,
        setShowUploadInvoice,
        originalInvoiceId,
        setOriginalInvoiceId,
        reasonId,
        setReasonId,
    };

    return <InvoiceManagementContext.Provider value={value}>{props.children}</InvoiceManagementContext.Provider>;
};

export default InvoiceManagementProvider;
